import { call, put, select } from 'redux-saga/effects';
import { CreateListingAsyncActions } from 'store/actions/createListing';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';

function* create(action) {
  const {
    CreateListing: {
      Actions: { SUCCESS, FAILURE },
    },
  } = CreateListingAsyncActions;
  const {
    payload: { listing },
  } = action;

  const listingAgentId = yield select((state) => state.auth.user.id);

  try {
    const response = yield call(apiCall, '/listings', 'post', { ...listing, listingAgentId });
    yield put(SUCCESS(response.data));
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default create;
